// The Academy's copy, in our own words (docs/tickets/217/design.md, "UX copy"),
// authored in nl and en. i18n.ts spreads these into its two dictionaries; the
// other five locales fall back to nl through translate() until content for
// them exists. Counts that the design wrote as 60 and 48 read {total} and
// {bar} here, so the sitting's copy follows the manifest, never a constant.
export const learnCopy = {
  nl: {
    "learn.path.eyebrow-level": "Niveau {n} · {level}",
    "learn.path.lesson-of": "Les {n} van {total} · {module}",
    "learn.path.step-of": "Stap {n} van {total}",
    "learn.path.primary-start": "Begin les",
    "learn.path.primary-continue": "Ga verder",
    "learn.path.primary-taste": "Proef voor deze les",
    "learn.path.primary-drills": "Oefen {n} items",
    "learn.path.primary-lessons": "Bekijk je lessen",
    "learn.path.primary-aria": "{action} — {lesson}",
    "learn.path.drills-title": "Oefenen zonder glas",
    "learn.path.drills-due": "{n} oefeningen staan klaar",
    "learn.path.drills-none": "Niets te oefenen · volgende op {date}",
    "learn.path.prove-title": "Bewijs niveau 1 met de checks",
    "learn.path.prove-hint": "Eén zitting van {total} checks, zonder glas",
    "learn.path.prove-retake": "Herkansing staat open",
    "learn.path.prove-wait": "Herkansen kan vanaf {time}",
    "learn.path.coaching-title": "Je zitting van {date}: {n} van {total}",
    "learn.path.fail-modules": "Bestudeer eerst: {modules}",
    "learn.path.organise-title": "Organiseer een proeverij voor deze les",
    "learn.path.organise-hint": "{format} · {n} wijnen, al ingevuld",
    "learn.path.templates-title": "Proeverijsjablonen",
    "learn.path.templates-hint": "Per druif, land of regio",
    "learn.path.streak": "weken op rij geleerd",
    "learn.path.lessons-done": "lessen afgerond",
    "learn.path.items-secure": "oefenitems zeker",
    "learn.path.levels-title": "Je niveaus",
    "learn.path.checklists-title": "Checklists van je niveau",
    "learn.path.error-refresh":
      "Je voortgang kon niet worden ververst; je ziet de opgeslagen kopie.",
    "learn.path.sync-refused":
      "Eén stap kon niet worden gesynchroniseerd en is opzij gezet. De rest is bijgewerkt.",
    "learn.path.next-coming":
      "Niveau 3 komt eraan: Terroir en kwaliteit. Je oefeningen lopen gewoon door.",
    "learn.level.state-current": "Nu bezig",
    "learn.level.state-complete": "Afgerond",
    "learn.level.state-passed": "Gehaald via de checks",
    "learn.level.state-optional": "Optioneel · lessen open",
    "learn.level.state-locked": "Nog gesloten",
    "learn.level.state-coming": "Komt eraan",
    "learn.level.mastery": "beheersing",
    "learn.level.mastery-aria": "Beheersing {n} procent",
    "learn.level.locked-body": "Rond eerst Proeven leren af, of haal de checks.",
    "learn.level.locked-to-level1": "Naar niveau 1",
    "learn.level.breakdown-hint":
      "Beheersing: de helft lessen, een kwart checks, een kwart oefeningen.",
    "learn.level.lessons-count": "{done} van {total} lessen",
    "learn.level.checks-count": "{done} van {total} checks goed",
    "learn.level.drills-count": "{done} van {total} oefenitems zeker",
    "learn.level.module": "Module {n} · {name}",
    "learn.level.templates": "Proeverijsjablonen voor dit niveau",
    "learn.lesson.state-done": "Afgerond",
    "learn.lesson.state-progress": "Bezig",
    "learn.lesson.state-paused": "Gepauzeerd",
    "learn.lesson.no-taste": "Zonder proefstap",
    "learn.lesson.step-of": "Stap {n} van {total} · {kind}",
    "learn.lesson.steps-label": "Stappen van deze les",
    "learn.lesson.step-marker": "Stap {n} van {total}: {kind}",
    "learn.lesson.kind-read": "Lezen",
    "learn.lesson.kind-check": "Check",
    "learn.lesson.kind-taste": "Proeven",
    "learn.lesson.kind-drill": "Oefenen",
    "learn.lesson.back-to-path": "Terug naar je pad",
    "learn.lesson.sources": "Bronnen",
    "learn.lesson.source-accessed": "geraadpleegd {date}",
    "learn.lesson.source-external": "opent in een nieuw venster",
    "learn.lesson.term-hint": "Houd een woord ingedrukt voor uitleg",
    "learn.lesson.swipe-hint": "Veeg om verder te gaan",
    "learn.lesson.paused-title": "Deze les is even gepauzeerd",
    "learn.lesson.paused-body":
      "We kijken hem na. Je voortgang blijft bewaard en je pad gaat verder met de volgende les.",
    "learn.lesson.notfound-title": "Les niet gevonden",
    "learn.lesson.complete-title": "Les afgerond",
    "learn.lesson.complete-with-note": "Met een notitie uit het glas",
    "learn.lesson.complete-no-taste": "Zonder proefstap",
    "learn.lesson.complete-mastery": "Beheersing niveau {level}: {from}% → {to}%",
    "learn.lesson.complete-next": "Volgende les: {lesson}",
    "learn.lesson.level-complete": "Niveau {n} afgerond — {next} staat open",
    "learn.check.option-aria": "Antwoord {n}: {text}",
    "learn.check.correct": "Goed",
    "learn.check.incorrect": "Niet juist",
    "learn.check.correct-was": "Het juiste antwoord: {answer}",
    "learn.check.retry": "Opnieuw proberen",
    "learn.check.gate": "Kies eerst een antwoord om verder te gaan.",
    "learn.check.answered-live": "Je antwoord: {answer}. {verdict}. {explanation}",
    "learn.taste.format-single": "Eén glas",
    "learn.taste.format-horizontal": "Horizontaal",
    "learn.taste.format-vertical": "Verticaal",
    "learn.taste.format-diagonal": "Diagonaal",
    "learn.taste.hint-horizontal": "Dezelfde stijl, andere herkomst of maker",
    "learn.taste.hint-vertical": "Eén wijn, meerdere jaargangen",
    "learn.taste.hint-diagonal": "Maker én jaargang verschillen",
    "learn.taste.wines-count": "{n} wijnen",
    "learn.taste.archetype": "Wijn {n}",
    "learn.taste.vintage": "Jaargang",
    "learn.taste.attach": "Kies uit je notities",
    "learn.taste.new-note": "Nieuwe notitie",
    "learn.taste.defer": "Vanavond geen glas",
    "learn.taste.deferred": "Uitgesteld — kom terug met een glas. De rest van de les staat open.",
    "learn.taste.organise": "Organiseer een proeverij",
    "learn.taste.attach-flight": "Koppel een proeverij",
    "learn.taste.attached": "Gekoppeld",
    "learn.taste.from-flight": "Uit proeverij",
    "learn.taste.also-lesson": "Ook bij les {lesson}",
    "learn.taste.replace": "Wissel",
    "learn.taste.note-removed":
      "Deze notitie is uit je journaal verwijderd. De les blijft afgerond.",
    "learn.taste.fit-warning": "Deze {wine} past niet bij ‘{archetype}’.",
    "learn.taste.fit-alternatives": "Past wel bij: {archetypes}. Jij beslist.",
    "learn.taste.fit-none": "Past bij geen van de wijnen in deze stap. Jij beslist.",
    "learn.taste.fit-anyway": "Toch koppelen",
    "learn.taste.fit-other": "Andere notitie",
    "learn.taste.comparison-title": "Wat je proefde, naast elkaar",
    "learn.taste.sparing": "Kleine schenk, spugen mag. Proeven is een vaardigheid.",
    "learn.taste.picker-title": "Jouw notities",
    "learn.taste.picker-empty": "Nog geen notities. Maak er een met een glas in de hand.",
    "learn.taste.picker-flights": "Uit proeverijen",
    "learn.taste.flight-picker-title": "Welke wijn hoort bij welke?",
    "learn.taste.flight-picker-confirm": "Koppelen",
    "learn.taste.flight-none-fits":
      "Deze proeverij past bij geen stap: een vergelijking heeft twee tot zes wijnen. Je notities tellen wel voor je streak en checklists.",
    "learn.drills.title": "Oefenen",
    "learn.drills.session-of": "{n} van {total}",
    "learn.drills.kind-aroma": "Aroma",
    "learn.drills.kind-marker": "Structuur",
    "learn.drills.first-exposure": "Nieuw",
    "learn.drills.smell-prompt": "Ruik aan referentie {code} van les ‘{lesson}’",
    "learn.drills.item-needed": "Geen wijn nodig, wel dit: {reference}",
    "learn.drills.no-reference": "Geen referentie bij de hand? Lees de beschrijving",
    "learn.drills.guess-prompt": "Wat ruik je? Kies eerst de familie, dan het aroma.",
    "learn.drills.call-prompt": "Waar zet je dit op de ladder?",
    "learn.drills.confirm": "Bevestig",
    "learn.drills.next": "Volgende",
    "learn.drills.reveal-was": "Het was {descriptor}",
    "learn.drills.reveal-cluster": "{cluster} · {origin}",
    "learn.drills.reveal-reference": "Thuisreferentie: {reference}",
    "learn.drills.verdict-correct": "Goed geraden",
    "learn.drills.verdict-incorrect": "Niet deze",
    "learn.drills.verdict-exact": "Precies",
    "learn.drills.verdict-near": "Dichtbij — telt niet als goed",
    "learn.drills.your-call": "Jouw keuze",
    "learn.drills.right-call": "Juist",
    "learn.drills.prepare-note":
      "Geen wijn nodig voor deze oefening, wel wat gewone dingen uit de keuken, bijvoorbeeld een schijfje appel.",
    "learn.drills.prepare": "Zet klaar en label: {items}",
    "learn.drills.intro":
      "Deze les brengt {n} oefeningen mee. Je doet ze nu één keer; daarna komen ze terug als het tijd is.",
    "learn.drills.cap-title": "Klaar voor vandaag",
    "learn.drills.cap-body": "Je deed {n} oefeningen. De rest ({rest}) komt morgen terug.",
    "learn.drills.empty-title": "Niets te oefenen",
    "learn.drills.empty-body": "De volgende oefening staat klaar op {date}.",
    "learn.drills.empty-none-yet": "Oefeningen komen vrij met je eerste les.",
    "learn.drills.all-done-title": "Alles geoefend",
    "learn.drills.to-lesson": "Naar de volgende les",
    "learn.drills.option-aria": "Optie {n}: {label}",
    "learn.drills.swipe-hint": "Tik of veeg een optie",
    "learn.drills.live-result": "{verdict}. {explanation}",
    "learn.prove.title": "Bewijs niveau 1",
    "learn.prove.intro-body":
      "Alle {total} checks van niveau 1 in één zitting, zonder glas, ongeveer twintig minuten. Vanaf {bar} goed staat niveau 2 open; de lessen van niveau 1 blijven open.",
    "learn.prove.abandon-note":
      "Stop je halverwege, dan tellen je antwoorden als gewone checks en komt er geen uitslag.",
    "learn.prove.start": "Begin de zitting",
    "learn.prove.resume": "Ga verder ({n} van {total})",
    "learn.prove.locked-until": "Herkansen kan vanaf {time}.",
    "learn.prove.check-of": "Check {n} van {total}",
    "learn.prove.stop": "Stoppen",
    "learn.prove.stop-confirm-title": "Zitting stoppen?",
    "learn.prove.stop-confirm-body":
      "Je antwoorden tot nu toe tellen als gewone checks. Er komt geen uitslag.",
    "learn.prove.stop-confirm-yes": "Ja, stoppen",
    "learn.prove.stop-confirm-no": "Doorgaan",
    "learn.prove.pass-title": "Gehaald: {n} van {total}",
    "learn.prove.pass-body":
      "Niveau 2 staat open. Niveau 1 blijft open voor als je de lessen later wilt doen.",
    "learn.prove.fail-title": "{n} van {total} — nog niet",
    "learn.prove.fail-body": "Je miste het meest in:",
    "learn.prove.study-module": "Bestudeer {module}",
    "learn.prove.to-level2": "Naar niveau 2",
    "learn.templates.title": "Proeverijsjablonen",
    "learn.templates.hint":
      "Een vergelijkende proeverij per druif, land of regio — alleen wat je al bereikt hebt.",
    "learn.templates.kind-grape": "Druif",
    "learn.templates.kind-country": "Land",
    "learn.templates.kind-region": "Regio",
    "learn.templates.counts": "{h} horizontaal · {v} verticaal · {d} diagonaal",
    "learn.templates.serves": "Dient les {lesson}",
    "learn.templates.organise": "Organiseer",
    "learn.templates.empty-title": "Nog geen sjablonen",
    "learn.templates.empty-body":
      "Sjablonen komen vrij zodra je de les over die druif, dat land of die regio bereikt.",
    "flight.lesson.eyebrow": "Vanuit les: {lesson}",
    "flight.template.eyebrow": "Sjabloon",
    "flight.lesson.pour": "Te schenken, in deze volgorde",
    "flight.lesson.pick-bottle": "Kies de fles",
    "flight.lesson.bottle-for": "Fles voor wijn {n}: {archetype}",
    "flight.lesson.framing-title": "{format} · {n} wijnen",
    "flight.lesson.archetype-of": "Wijn {n} van {total} · {archetype}",
    "flight.lesson.attached": "Je notities zijn gekoppeld aan je les",
    "flight.lesson.kept": "Je notities blijven bewaard voor als je deze les bereikt",
    "flight.lesson.attach-to-lesson": "Koppel aan een les",
    "flight.host.template-entry": "Begin met een sjabloon",
    "flight.host.create-needs-bottles": "Kies eerst een fles voor elke wijn",
    "learn.check.of": "Vraag {n} van {total}",
    "learn.lesson.complete-streak": "{n} weken op rij geleerd",
    "learn.level.eyebrow": "Niveau {n}",
    "learn.lesson.prev": "Vorige stap",
    "learn.lesson.next": "Volgende stap",
    "learn.term.explain": "Uitleg bij {term}",
    "learn.taste.note-removed-label": "Notitie verwijderd",
    "flight.attach.choose-title": "Bij welke les hoort deze proeverij?",
    "learn.lesson.read-aside": "Lees de tekst hiernaast en ga dan verder.",
    "learn.path.empty-title": "Het pad komt eraan",
    "learn.path.empty-body": "Zodra de lessen klaarstaan, begin je hier.",
  },
  en: {
    "learn.path.eyebrow-level": "Level {n} · {level}",
    "learn.path.lesson-of": "Lesson {n} of {total} · {module}",
    "learn.path.step-of": "Step {n} of {total}",
    "learn.path.primary-start": "Start lesson",
    "learn.path.primary-continue": "Continue",
    "learn.path.primary-taste": "Taste for this lesson",
    "learn.path.primary-drills": "Practise {n} items",
    "learn.path.primary-lessons": "See your lessons",
    "learn.path.primary-aria": "{action} — {lesson}",
    "learn.path.drills-title": "Practise without a glass",
    "learn.path.drills-due": "{n} items ready",
    "learn.path.drills-none": "Nothing due · next on {date}",
    "learn.path.prove-title": "Prove Level 1 by its checks",
    "learn.path.prove-hint": "One sitting of {total} checks, no glass needed",
    "learn.path.prove-retake": "Retake available",
    "learn.path.prove-wait": "Retake opens at {time}",
    "learn.path.coaching-title": "Your sitting of {date}: {n} of {total}",
    "learn.path.fail-modules": "Study first: {modules}",
    "learn.path.organise-title": "Organise a tasting for this lesson",
    "learn.path.organise-hint": "{format} · {n} wines, pre-filled",
    "learn.path.templates-title": "Tasting templates",
    "learn.path.templates-hint": "By grape, country or region",
    "learn.path.streak": "weeks learning in a row",
    "learn.path.lessons-done": "lessons completed",
    "learn.path.items-secure": "drill items secure",
    "learn.path.levels-title": "Your levels",
    "learn.path.checklists-title": "Your level's checklists",
    "learn.path.error-refresh": "Your progress could not be refreshed; this is the saved copy.",
    "learn.path.sync-refused":
      "One step could not be synced and was set aside. The rest is up to date.",
    "learn.path.next-coming": "Level 3 is coming: Terroir and quality. Your drills keep going.",
    "learn.level.state-current": "Current",
    "learn.level.state-complete": "Complete",
    "learn.level.state-passed": "Passed by its checks",
    "learn.level.state-optional": "Optional · lessons open",
    "learn.level.state-locked": "Still closed",
    "learn.level.state-coming": "Coming",
    "learn.level.mastery": "mastery",
    "learn.level.mastery-aria": "Mastery {n} percent",
    "learn.level.locked-body": "Finish Learning to taste first, or pass its checks.",
    "learn.level.locked-to-level1": "Go to Level 1",
    "learn.level.breakdown-hint": "Mastery: half lessons, a quarter checks, a quarter drills.",
    "learn.level.lessons-count": "{done} of {total} lessons",
    "learn.level.checks-count": "{done} of {total} checks right",
    "learn.level.drills-count": "{done} of {total} drill items secure",
    "learn.level.module": "Module {n} · {name}",
    "learn.level.templates": "Tasting templates for this level",
    "learn.lesson.state-done": "Completed",
    "learn.lesson.state-progress": "In progress",
    "learn.lesson.state-paused": "Paused",
    "learn.lesson.no-taste": "No taste step",
    "learn.lesson.step-of": "Step {n} of {total} · {kind}",
    "learn.lesson.steps-label": "Steps of this lesson",
    "learn.lesson.step-marker": "Step {n} of {total}: {kind}",
    "learn.lesson.kind-read": "Read",
    "learn.lesson.kind-check": "Check",
    "learn.lesson.kind-taste": "Taste",
    "learn.lesson.kind-drill": "Drill",
    "learn.lesson.back-to-path": "Back to your path",
    "learn.lesson.sources": "Sources",
    "learn.lesson.source-accessed": "accessed {date}",
    "learn.lesson.source-external": "opens in a new window",
    "learn.lesson.term-hint": "Press and hold a word for its meaning",
    "learn.lesson.swipe-hint": "Swipe to continue",
    "learn.lesson.paused-title": "This lesson is paused for now",
    "learn.lesson.paused-body":
      "We are checking it. Your progress is kept and your path moves on to the next lesson.",
    "learn.lesson.notfound-title": "Lesson not found",
    "learn.lesson.complete-title": "Lesson complete",
    "learn.lesson.complete-with-note": "With a note from the glass",
    "learn.lesson.complete-no-taste": "Without a taste step",
    "learn.lesson.complete-mastery": "Level {level} mastery: {from}% → {to}%",
    "learn.lesson.complete-next": "Next lesson: {lesson}",
    "learn.lesson.level-complete": "Level {n} complete — {next} is open",
    "learn.check.option-aria": "Answer {n}: {text}",
    "learn.check.correct": "Right",
    "learn.check.incorrect": "Not quite",
    "learn.check.correct-was": "The right answer: {answer}",
    "learn.check.retry": "Try again",
    "learn.check.gate": "Pick an answer to continue.",
    "learn.check.answered-live": "Your answer: {answer}. {verdict}. {explanation}",
    "learn.taste.format-single": "One glass",
    "learn.taste.format-horizontal": "Horizontal",
    "learn.taste.format-vertical": "Vertical",
    "learn.taste.format-diagonal": "Diagonal",
    "learn.taste.hint-horizontal": "Same style, different place or producer",
    "learn.taste.hint-vertical": "One wine, several vintages",
    "learn.taste.hint-diagonal": "Producer and vintage both differ",
    "learn.taste.wines-count": "{n} wines",
    "learn.taste.archetype": "Wine {n}",
    "learn.taste.vintage": "Vintage",
    "learn.taste.attach": "Pick from your notes",
    "learn.taste.new-note": "New note",
    "learn.taste.defer": "No glass tonight",
    "learn.taste.deferred": "Deferred — come back with a glass. The rest of the lesson is open.",
    "learn.taste.organise": "Organise a tasting",
    "learn.taste.attach-flight": "Attach a tasting",
    "learn.taste.attached": "Attached",
    "learn.taste.from-flight": "From a tasting",
    "learn.taste.also-lesson": "Also in lesson {lesson}",
    "learn.taste.replace": "Swap",
    "learn.taste.note-removed":
      "This note was removed from your journal. The lesson stays complete.",
    "learn.taste.fit-warning": "This {wine} does not fit ‘{archetype}’.",
    "learn.taste.fit-alternatives": "It would fit: {archetypes}. Your call.",
    "learn.taste.fit-none": "Fits none of the wines in this step. Your call.",
    "learn.taste.fit-anyway": "Attach anyway",
    "learn.taste.fit-other": "Another note",
    "learn.taste.comparison-title": "What you tasted, side by side",
    "learn.taste.sparing": "A small pour, spitting is fine. Tasting is a skill.",
    "learn.taste.picker-title": "Your notes",
    "learn.taste.picker-empty": "No notes yet. Make one with a glass in hand.",
    "learn.taste.picker-flights": "From tastings",
    "learn.taste.flight-picker-title": "Which wine goes where?",
    "learn.taste.flight-picker-confirm": "Attach",
    "learn.taste.flight-none-fits":
      "This tasting fits no step: a comparison holds two to six wines. Your notes still count for your streak and checklists.",
    "learn.drills.title": "Practise",
    "learn.drills.session-of": "{n} of {total}",
    "learn.drills.kind-aroma": "Aroma",
    "learn.drills.kind-marker": "Structure",
    "learn.drills.first-exposure": "New",
    "learn.drills.smell-prompt": "Smell reference {code} from the lesson ‘{lesson}’",
    "learn.drills.item-needed": "No wine needed, just this: {reference}",
    "learn.drills.no-reference": "No reference at hand? Read the description",
    "learn.drills.guess-prompt": "What do you smell? Pick the family first, then the aroma.",
    "learn.drills.call-prompt": "Where does this sit on the ladder?",
    "learn.drills.confirm": "Confirm",
    "learn.drills.next": "Next",
    "learn.drills.reveal-was": "It was {descriptor}",
    "learn.drills.reveal-cluster": "{cluster} · {origin}",
    "learn.drills.reveal-reference": "Household reference: {reference}",
    "learn.drills.verdict-correct": "Good call",
    "learn.drills.verdict-incorrect": "Not this one",
    "learn.drills.verdict-exact": "Spot on",
    "learn.drills.verdict-near": "Close — does not count as right",
    "learn.drills.your-call": "Your call",
    "learn.drills.right-call": "Right",
    "learn.drills.prepare-note":
      "No wine needed for this one, just a few ordinary things from the kitchen, for example a slice of apple.",
    "learn.drills.prepare": "Prepare and label: {items}",
    "learn.drills.intro":
      "This lesson brings {n} drill items. You do them once now; after that they return when it is time.",
    "learn.drills.cap-title": "Done for today",
    "learn.drills.cap-body": "You did {n} items. The rest ({rest}) comes back tomorrow.",
    "learn.drills.empty-title": "Nothing to practise",
    "learn.drills.empty-body": "Your next item is due on {date}.",
    "learn.drills.empty-none-yet": "Drills unlock with your first lesson.",
    "learn.drills.all-done-title": "All practised",
    "learn.drills.to-lesson": "To the next lesson",
    "learn.drills.option-aria": "Option {n}: {label}",
    "learn.drills.swipe-hint": "Tap or swipe an option",
    "learn.drills.live-result": "{verdict}. {explanation}",
    "learn.prove.title": "Prove Level 1",
    "learn.prove.intro-body":
      "All {total} Level 1 checks in one sitting, no glass, about twenty minutes. From {bar} right, Level 2 opens; the Level 1 lessons stay open.",
    "learn.prove.abandon-note":
      "Stop halfway and your answers count as ordinary checks; there is no result.",
    "learn.prove.start": "Start the sitting",
    "learn.prove.resume": "Continue ({n} of {total})",
    "learn.prove.locked-until": "You can retake from {time}.",
    "learn.prove.check-of": "Check {n} of {total}",
    "learn.prove.stop": "Stop",
    "learn.prove.stop-confirm-title": "Stop the sitting?",
    "learn.prove.stop-confirm-body":
      "Your answers so far count as ordinary checks. There is no result.",
    "learn.prove.stop-confirm-yes": "Yes, stop",
    "learn.prove.stop-confirm-no": "Keep going",
    "learn.prove.pass-title": "Passed: {n} of {total}",
    "learn.prove.pass-body":
      "Level 2 is open. Level 1 stays open in case you want its lessons later.",
    "learn.prove.fail-title": "{n} of {total} — not yet",
    "learn.prove.fail-body": "You missed most in:",
    "learn.prove.study-module": "Study {module}",
    "learn.prove.to-level2": "Go to Level 2",
    "learn.templates.title": "Tasting templates",
    "learn.templates.hint":
      "A comparative tasting per grape, country or region — only what you have reached.",
    "learn.templates.kind-grape": "Grape",
    "learn.templates.kind-country": "Country",
    "learn.templates.kind-region": "Region",
    "learn.templates.counts": "{h} horizontal · {v} vertical · {d} diagonal",
    "learn.templates.serves": "Serves lesson {lesson}",
    "learn.templates.organise": "Organise",
    "learn.templates.empty-title": "No templates yet",
    "learn.templates.empty-body":
      "Templates unlock as soon as you reach the lesson on that grape, country or region.",
    "flight.lesson.eyebrow": "From lesson: {lesson}",
    "flight.template.eyebrow": "Template",
    "flight.lesson.pour": "To pour, in this order",
    "flight.lesson.pick-bottle": "Pick the bottle",
    "flight.lesson.bottle-for": "Bottle for wine {n}: {archetype}",
    "flight.lesson.framing-title": "{format} · {n} wines",
    "flight.lesson.archetype-of": "Wine {n} of {total} · {archetype}",
    "flight.lesson.attached": "Your notes are attached to your lesson",
    "flight.lesson.kept": "Your notes are kept for when you reach this lesson",
    "flight.lesson.attach-to-lesson": "Attach to a lesson",
    "flight.host.template-entry": "Start from a template",
    "flight.host.create-needs-bottles": "Pick a bottle for every wine first",
    "learn.check.of": "Question {n} of {total}",
    "learn.lesson.complete-streak": "{n} weeks learning in a row",
    "learn.level.eyebrow": "Level {n}",
    "learn.lesson.prev": "Previous step",
    "learn.lesson.next": "Next step",
    "learn.term.explain": "What {term} means",
    "learn.taste.note-removed-label": "Note removed",
    "flight.attach.choose-title": "Which lesson does this tasting belong to?",
    "learn.lesson.read-aside": "Read the text alongside, then continue.",
    "learn.path.empty-title": "The path is coming",
    "learn.path.empty-body": "As soon as the lessons are ready, you start here.",
  },
} as const;
